
<template>
  <!-- 产品中心.vue -->
  <div id="product">
    <!-- <router-link to="/HelloWorld">home</router-link> -->
    <div class="product-head">
      <span class="unified-module-title">产品中心</span>
      <p style="color:rgb(120, 120, 120);">汇集校园设备智能互联</p>
    </div>
    <div class="product-center">
      <!-- <div class="prev" v-on:click="moveUp()">
        <i class="fa fa-chevron-left"></i>
      </div>-->
      <ul class="items-box">
        <li
          v-for="item in productFigure"
          :key="item.id"
          v-on:mouseenter="showProductInfo($event)"
          v-on:mouseleave="hideInfo($event)"
        >
          <img :src="item.url" alt height="40px">
          <span>{{item.title}}</span>
          <div class="product-info">
            <!-- <div class="info-bg"></div> -->
          </div>
        </li>
      </ul>
      <!-- <div class="last" v-on:click="moveDown()">
        <i class="fa fa-chevron-right"></i>
      </div>-->
    </div>
    <div class="directional-control">
      <button class="prev-btn" v-on:click="moveUp">
        <i class="fa fa-chevron-left"></i>
      </button>
      <button class="last-btn" v-on:click="moveDown">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>
<style scoped>
#product {
  width: 100%;
  /* background-color: #f2f2f2; */
  /* height: 250px; */
}
.product-center {
  width: 1200px;
  height: 250px;
  margin: 10px auto;
  background-color: #f2f2f2;
  position: relative;
  box-shadow: 0 0 1px -1px rgba(191, 191, 191, 0.5);
  position: relative;
  overflow: hidden;
}
.product-center ul {
  position: absolute;
  left: 0;
  top: 0;
  /* transition: 0.3s; */
}
.product-center li {
  width: 400px;
  height: 250px;
  background-color: #fff;
  float: left;
  box-sizing: border-box;
  text-align: center;
  line-height: 250px;
  /* border-right: 1px solid #f2f2f2; */
  position: relative;
  cursor: pointer;
}
.prev-btn,
.last-btn {
  width: 36px;
  height: 36px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: 0.3s;
  outline: none;
}
.prev-btn:hover,
.last-btn:hover {
  background: #000;
  color: #fff;
}

/* .prev,
.last {
  width: 20px;
  height: 40px;
  background-color: #ccc;
  cursor: pointer;
  position: absolute;
  top: 50%;
  line-height: 40px;
  text-align: center;
  margin: -20px 0 0 0px;
  z-index: 9999;
}
.prev {
  left: 0px;
}
.last {
  right: 0px;
} */
/* .product-title {
  padding: 30px 0 15px 0px;
  text-align: center;
  letter-spacing: 5px;
  font-size: 30px;
  display: inline-block;
  font-family: "Microsoft YaHei", 微软雅黑, MicrosoftJhengHei, 华文细黑, STHeiti,
    MingLiu;
} */


.product-head {
  width: 100%;
  height: 100%;
  text-align: center;
}
.product-info {
  width: 400px;
  /* height: 40px; */
  height: 250px;
  /* background: #ccc; */
  line-height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.3;
  display: none;
  /* opacity:0.3; */
  /* top: 290px; */
  transition: all 1s;
  /* transform: scale(0); */
}
.info-bg {
  /* position: absolute;
  left: 0;
  top: 0; */
  background: #000;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  z-index: 999;
  display: none;
}
.directional-control {
  margin-top: 15px;
  text-align: center;
}
/* .decoration {
  display: inline-block;
  width:90px;
  height: 2px;
  background: #ff871c;
  margin-bottom: 20px;
} */
</style>
<script>
export default {
  name: "product",
  data() {
    return {
      /** 产品图信息 */
      productFigure: [
        { url: "", href: "", title: "1" },
        { url: "", href: "", title: "2" },
        { url: "", href: "", title: "3" },
        { url: "", href: "", title: "4" },
        { url: "", href: "", title: "5" },
        { url: "", href: "", title: "6" },
        { url: "", href: "", title: "7" },
        { url: "", href: "", title: "8" },
        { url: "", href: "", title: "9" },
        { url: "", href: "", title: "10" },
        { url: "", href: "", title: "11" },
        { url: "", href: "", title: "12" }
      ]
    };
  },
  components: {
    // ce
  },
  methods: {
    /** 上移 */
    moveUp: function() {
      // 上是加，下是减
      /** 总长度 */
      var currentLeft = $(".items-box")[0].offsetLeft;
      /** 说明已经上移到头 */
      if (currentLeft == 0) {
        return;
      }
      var left = currentLeft + 1200;
      $(".items-box").css("left", left);
    },
    /** 下移 */
    moveDown: function() {
      var totalLength = 400 * this.productFigure.length;
      var currentLeft = $(".items-box")[0].offsetLeft;
      /** 说明下移到底 */
      if (currentLeft == 1200 - totalLength) {
        return;
      }
      $(".items-box").css("left", currentLeft - 1200);
    },
    /** 显示产品信息 */
    showProductInfo: function(e) {
      console.log(e.target);
      $(e.target)
        .find(".product-info")
        .css({
          display: "block"
          // top: 210,
          // transform: "scale(1)"
        });
      console.log("显示产品信息");
    },
    /** 滑出隐藏信息 */
    hideInfo: function(e) {
      $(e.target)
        .find(".product-info")
        .css({
          display: "none"
          // top: 290,
          // transform: "scale(0)"
        });
    }
    /**函数防抖 */
    // debounce: function(fn, time) {
    //   let timer;
    //   time || (time = 250);
    //   return function() {
    //     var context = this;
    //     var args = arguments;
    //     clearTimeout(timer);
    //     timer = setTimeout(function() {
    //       fn.apply(context, args);
    //     }, time);
    //   };
    // }
  },
  computed: {}
};
</script>




// WEBPACK FOOTER //
// src/components/product.vue